import React, { useRef, useEffect, useState } from 'react'
import { Card, Row, Col, Input, Spin, Alert } from 'antd'
import { useSelector } from 'react-redux'
import { handleChange, formatMessage } from '../../utils/common'
import { sortOutSku } from '../../services/Sort/sortout'
import { modalError } from '../../utils/modalUtils'

let instance1 = null
let instance2 = null
const Enumobj = {
  nfc: 'NFC',
  rfid: 'RFID',
  normal: 'NORMAL'
}
const SortOutPage = () => {
  const inputRef = useRef(null)
  const [currentLabel, setCurrentLabel] = useState([])
  const [isBlur, setIsBlur] = useState(false)
  const [spinLoading] = useState(false)
  const [upcValue, setUpcValue] = useState('')
  const [themeObj, setThemeObj] = useState({ width: 750, height: 400, padding: 24 })
  const deviceSize = useSelector(state => state.commonStore.deviceSize)
  const commonStore = useSelector(state => state.commonStore)
  useEffect(() => {
    setThemeObj({ width: 500 * deviceSize, height: 266 * deviceSize, padding: 16 * deviceSize })
    inputRef.current.focus({
      cursor: 'all'
    })
    window.addEventListener('keydown', onKeyDownBtn) // 添加全局事件
    return () => {
      window.removeEventListener('keydown', onKeyDownBtn) // 销毁
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const onKeyDownBtn = e => {
    switch (e.keyCode) {
      case 13:
        if (instance1) {
          instance1.destroy()
          instance1 = null
          // 清空数据
          setUpcValue('')
          // 获取焦点
          inputRef.current.focus({
            cursor: 'all'
          })
        }
        if (instance2) {
          instance2.destroy()
          instance2 = null
          // 清空数据
          setUpcValue('')
          // 获取焦点
          inputRef.current.focus({
            cursor: 'all'
          })
        }
        break
      default:
        break
    }
  }

  const onKeyDown = e => {
    switch (e.keyCode) {
      case 13:
        sortSKU()
        break
      default:
        break
    }
  }

  const onFocusFun = e => {
    setIsBlur(false)
  }

  useEffect(() => {
    if (upcValue?.length === 0) {
      setCurrentLabel([])
    }
  }, [upcValue])

  const sortSKU = () => {
    if (upcValue?.length === 0) {
      return
    }
    const params = {
      upc: upcValue
    }
    sortOutSku(params)
      .then(res => {
        if (res.errorCode === '200') {
          setCurrentLabel(res.resultData)
          inputRef.current.focus({
            cursor: 'all'
          })
        }
      })
      .catch(error => {
        if (error.errorCode === '435') {
          instance1 = modalError({
            content: formatMessage(commonStore, 'languageObj.waverun.illegalUPC')
          })
        }
        if (error.errorCode === '433') {
          instance2 = modalError({
            content: formatMessage(commonStore, 'languageObj.waverun.paramEmpty')
          })
        }
      })
  }

  const onBlurFun = e => {
    setIsBlur(true)
  }
  const showError = () => {
    return isBlur && !upcValue
  }
  return (
    <div style={{ height: '100%' }}>
      <div className="tag-container">
        <Spin spinning={spinLoading} size="large">
          <Card
            style={{
              ...themeObj
            }}
            className="nfc_card"
          >
            {showError() ? (
              <Row type="flex" justify="center">
                <Col style={{ textAlign: 'right' }} span={3}></Col>
                <Col span={15}>
                  <Alert
                    className="mb15"
                    type="error"
                    message={formatMessage(commonStore, 'languageObj.nsptagLocale.blurTip')}
                    banner
                  />
                </Col>
              </Row>
            ) : (
              <div style={{ height: 45 }} className="mb15"></div>
            )}
            <Row>
              <Col span={3}></Col>
              <Col style={{ textAlign: 'left', display: 'flex', alignItems: 'center' }} span={3}>
                UPC：
              </Col>
              <Col span={15}>
                <Input
                  value={upcValue}
                  ref={inputRef}
                  onChange={e => handleChange(e, { setState: setUpcValue })}
                  placeholder={formatMessage(commonStore, 'languageObj.nsptagLocale.pleaseScan') + 'UPC'}
                  allowClear
                  onKeyUp={e => onKeyDown(e)}
                  onBlur={e => onBlurFun(e)}
                  onFocus={e => onFocusFun(e)}
                />
              </Col>
              <Col span={3}></Col>
            </Row>
            <Row>
              <Col span={24}>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '30px' }}>
                  <div
                    className="nike_sortbox mt15"
                    style={{ background: currentLabel.indexOf(Enumobj.nfc) !== -1 ? '#DF4214' : '#FFF' }}
                  >
                    NFC
                  </div>
                  <div
                    className="nike_sortbox mt15"
                    style={{ background: currentLabel.indexOf(Enumobj.rfid) !== -1 ? '#DF4214' : '#FFF' }}
                  >
                    RFID
                  </div>
                  <div
                    className="nike_sortbox mt15"
                    style={{ background: currentLabel.indexOf(Enumobj.normal) !== -1 ? '#DF4214' : '#FFF' }}
                  >
                    {formatMessage(commonStore, 'languageObj.sortout.normal')}
                  </div>
                </div>
              </Col>
            </Row>
          </Card>
        </Spin>
      </div>
    </div>
  )
}
export default SortOutPage
